/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RepairOrgPathResponse } from '../../models/repair-org-path-response';

export interface ValidateOrgPathAsync$Plain$Params {
  companyId: number;
}

export function validateOrgPathAsync$Plain(http: HttpClient, rootUrl: string, params: ValidateOrgPathAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
  const rb = new RequestBuilder(rootUrl, validateOrgPathAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RepairOrgPathResponse>;
    })
  );
}

validateOrgPathAsync$Plain.PATH = '/company/{companyId}/validate-org-path';
